// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"891":"871bb62f","949":"bb0e6f61"}[chunkId] + ".chunk.js";
};